var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"receive-dialog"},[_vm._t("title"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_c('a',{staticClass:"close",attrs:{"href":"javascript:;"},on:{"click":_vm.handleClose}}),_vm._v(" "),_vm._t("footer")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }